import React from 'react';

export default class SignupEntry extends React.Component {
    remove() {
        this.props.remove(this.props.index);
    }

    update(e){
        var name = e.target.value;
        this.props.update(this.props.index, name)
    }

    getId() {
      return "attendee-input-" + this.props.index;
    }

    render() {
        return (
            <div className="form-group">
            <input name="names[]" id={this.getId()} className="form-control attendee-name hello" value={this.props.person.name} onChange={this.update.bind(this)} placeholder="Name" required />
            <input type="button" value="Remove" className="btn btn-sm btn-default attendee-remove" onClick={this.remove.bind(this)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop/SignupEntry.js